import React from 'react'
import Hero from './Hero'
import Products from './Products'
import LatestProduct from './LatestProduct'
import BestSeller from './BestSeller'
import Features from './Features'


function Home() {
    return (
        <>
            <Hero />
            <Features />
            <LatestProduct />
            <BestSeller />
            <Products />
        </>
    )
}

export default Home